
import common from '../../api/common';
import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import value2name from 'vux/src/filters/value2name.js'
import Toast from 'vux/src/components/toast/index.vue'

export default {
components: {
Group,
XAddress,
XButton,
Cell,
Toast
},
data() {
return {
code: '',

title: '',
value: [],
addressData: ChinaAddressV4Data,
showAddress: false,
istrue: false,
doctorname: this.$route.query.doctorname || '',
telephone: this.$route.query.telephone || '',
phoneCode: this.$route.query.phoneCode || '',
site: this.$route.query.site || '',//地址提交值
siteId: '',
hospitaid: this.$route.query.hospitaid || '',
hospitainfoName: this.$route.query.hospitainfoName || '',
count: '获取验证码',
isGet: true,
isSubmit: true,

showPositionValue: false, //是否显示提示
position: 'center', //提示信息的位置
toastText: '', // 提示文本
}
},

methods: {

doShowAddress () {
this.showAddress = true
setTimeout(() => {
this.showAddress = false
}, 2000)
},
onShadowChange (val,names) {
this.siteId = val.join();
this.site = names.join();
},

getWechatCode(){
this.code = common.getQueryString(window.location.search.substr(1), 'code');
},

getCode(){
if(this.isGet){
let _this = this;
let reg = /^1[3456789]\d{9}$/;
this.istrue = reg.test(this.telephone);
if(!this.istrue){
this.toastText = '请输入正确的手机号';
this.showPositionValue = true;
return;
}else{
this.isGet = false;

let params = {
parameters: this.telephone,
parametersone: 2
}
this.$doRequest("api/AppHomePage/getPcode", params,res => {

if(res.result == 4){
let num = 60;
let timer = setInterval(function () {
num--
_this.count = num + 's重新获取';
if (num === 0) {
_this.isGet = true;
_this.count = '获取验证码';
clearInterval(timer);
}
}, 1000);

}else{
this.toastText = '您已注册医生，请登录';
this.showPositionValue = true;
let num = 2;
let timer = setInterval(function () {
num--
if (num === 0) {
_this.$router.push({path: '/register',query: {code: _this.code}});
clearInterval(timer);
}
}, 1000);
}
});
}
}
},

submitRegister(){

var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
if(!this.doctorname || regEn.test(this.doctorname) || regCn.test(this.doctorname)){
this.toastText = '请输入正确格式的姓名';
this.showPositionValue = true;
}else if(!this.telephone){
this.toastText = '请输入正确格式的手机号';
this.showPositionValue = true;
}else if(!this.phoneCode){
this.toastText = '请输入正确格式的验证码';
this.showPositionValue = true;
}else if(!this.site){
this.toastText = '地区不能为空';
this.showPositionValue = true;
}else if(!this.hospitaid){
this.toastText = '请选中机构';
this.showPositionValue = true;
}else{
this.isSubmit = false;
let params = {
doctorname: this.doctorname,
telephone: this.telephone,
phoneCode: this.phoneCode,
site: this.site,
hospitaid: this.hospitaid
};
this.$doRequest("api/AppHomePage/doctorRegister", params,res => {
this.toastText = res.message;
this.showPositionValue = true;
this.$router.push({path: '/explain',query: {telephone: this.telephone}});
},err => {
this.isSubmit = true;
this.toastText = err.message;
this.showPositionValue = true;
});
}
},

goPath(){
this.$router.push({path: '/hospitalList', query: {
doctorname: this.doctorname,
telephone: this.telephone,
phoneCode: this.phoneCode,
site: this.site,
siteId: this.siteId,//做跳转用
hospitaid: this.hospitaid,
hospitainfoName: this.hospitainfoName
}
});
},

userAgreement(){
this.$router.push({path: '/userAgreement'});
}
},

created: function() {
if(this.$route.query.siteId){
this.value = this.$route.query.siteId.split(',');
}
this.getWechatCode();
document.title = '邀请注册';
}
}



// WEBPACK FOOTER //
// ./src/views/login/index.vue